{
    "common": {
        "dateFormatTitle": "Datumsformat",
        "dateFormatEU": "Europäisch",
        "dateFormatUS": "US-amerikanisch",
        "dateFormatISO": "ISO-Format",
        "timeFormatTitle": "Zeitformat",
        "timeFormat24Hour": "24-Stunden",
        "timeFormat12Hour": "12 Stunden"
    },
    "builderToast": {
        "details": "Details",
        "defaultTitle": "Unerwarteter Fehler",
        "defaultMessage": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
        "invalidContextTitle": "Ungültige Anfrage",
        "invalidContextMessage": "Die Anfrage ist ungültig.",
        "InvalidContentTitle": "Ungültiges Formular",
        "invalidContentMessage": "Ein oder mehrere Felder enthalten ungültige Werte.",
        "serviceMisconfiguredTitle": "Unvollständige Konfiguration",
        "serviceMisconfiguredMessage": "Bitte prüfen Sie die Konfiguration.",
        "errorWorkflowActionDispatch": "Die Aktion \"{name}\" ist fehlgeschlagen: ",
        "errorDataSourceDispatch": "Fehler beim Laden der Daten von \"{name}\": "
    },
    "dataProviderType": {
        "dataSource": "Datensätze",
        "dataSourceContext": "Verfügbare Optionen",
        "pageParameter": "Parameter",
        "currentRecord": "Datenquelle",
        "formData": "Formulardaten",
        "previousAction": "Vorherige Aktion",
        "user": "Benutzer"
    },
    "formDataProviderType": {
        "nodeMissing": "Fehlt"
    },
    "builderForm": {
        "submit": "Anwendung hinzufügen"
    },
    "sidebarComponentBuilder": {
        "settings": "Einstellungen",
        "createPage": "Neue Seite"
    },
    "builderSettingsModal": {
        "title": "Anwendung"
    },
    "builderSettingTypes": {
        "generalName": "Allgemein",
        "integrationsName": "Integrationen",
        "themeName": "Theme",
        "domainsName": "Domänen",
        "userSourcesName": "Benutzer"
    },
    "createPageModal": {
        "header": "Seite erstellen",
        "submit": "Seite hinzufügen"
    },
    "pageErrors": {
        "errorNameNotUnique": "Es existiert bereits eine Seite mit diesem Namen",
        "errorNameNotUniqueDescription": "Bitte geben Sie einen eindeutigen Namen für die Seite ein",
        "errorPathNotUnique": "Es existiert bereits ein Pfad mit diesem Namen",
        "errorStartingSlash": "Ein Pfad muss mit '/' beginnen",
        "errorValidPathCharacters": "Der Pfad enthält ungültige Zeichen",
        "errorUniquePathParams": "Pfad-Parameter müssen eindeutig sein.",
        "errorUniqueValidQueryParams": "Die Namen der Abfrageparameter müssen eindeutig und gültig sein."
    },
    "pageHeaderItemTypes": {
        "labelElements": "Elemente",
        "labelDataSource": "Daten",
        "labelVariables": "Variablen",
        "labelSettings": "Seiteneinstellungen"
    },
    "pageActionTypes": {
        "preview": "Vorschau",
        "publish": "Veröffentlichen"
    },
    "publishActionModal": {
        "title": "Veröffentlichen",
        "description": "Schalten Sie Ihre Anwendung live, indem Sie sie in einer der Domänen veröffentlichen. Beachten Sie, dass Ihre Anwendung mehrere Domänen haben kann, auf welchen jeweils eine andere Version der Anwendung läuft.",
        "publish": "Veröffentlichen",
        "publishSucceedTitle": "Seite veröffentlicht",
        "publishSucceedDescription": "Die Seite wurde erfolgreich veröffentlicht.",
        "publishSucceedLink": "Seite anzeigen",
        "publishFailedTitle": "Veröffentlichung der Seite fehlgeschlagen",
        "publishFailedDescription": "Die Veröffentlichung der Seite ist fehlgeschlagen. Bitte versuchen Sie es später erneut.",
        "openInNewTab": "In neuem Tab öffnen",
        "importingState": "Importiere",
        "noDomain": "Sie benötigen mindestens eine Domäne, um Ihre Anwendung zu veröffentlichen.",
        "addDomain": "Domain hinzufügen"
    },
    "lastPublishedDomainDate": {
        "neverPublished": "nie",
        "lastPublished": "Zuletzt veröffentlicht:"
    },
    "elementsContext": {
        "searchPlaceholder": "Elemente suchen",
        "noPageElements": "Für diese Seite wurden keine Elemente gefunden",
        "noElements": "Keine Elemente gefunden"
    },
    "elementType": {
        "heading": "Überschrift",
        "headingDescription": "Titel der Seitenüberschrift",
        "text": "Paragraph",
        "textDescription": "Mehrzeiliger Text",
        "link": "Verknüpfung",
        "linkDescription": "Ein Link zu einer Seite/URL",
        "image": "Bild",
        "imageDescription": "Bild anzeigen",
        "inputText": "Dateneingabe",
        "inputTextDescription": "Ein Dateneingabe-Feld",
        "column": "Spalten",
        "columnDescription": "Spalten-Container",
        "button": "Button",
        "buttonDescription": "Ein Button-Element",
        "table": "Tabelle",
        "tableDescription": "Ein Tabellen-Element",
        "formContainer": "Formular",
        "formContainerDescription": "Ein Formular-Element",
        "choice": "Auswahl",
        "choiceDescription": "Für die Auswahl einzelner/mehrerer Werte",
        "checkbox": "Kontrollkästchen",
        "checkboxDescription": "Kontrollkästchen-Element",
        "iframe": "iFrame",
        "iframeDescription": "Inline-Frame",
        "authForm": "Anmeldeformular",
        "authFormDescription": "Ein Benutzer-Anmeldeformular",
        "repeat": "Wiederholen",
        "repeatDescription": "Eine wiederholbare Menge an Elementen",
        "recordSelector": "Datensatz-Auswahl",
        "recordSelectorDescription": "Eine Bezugs-Datensatz-Auswahl",
        "dateTimePicker": "Datums- und Zeitauswahl",
        "dateTimePickerDescription": "Ein Eingabefeld für Datum und Zeit",
        "header": "Mehrseitiger Kopfbereich",
        "headerDescription": "Ein seitenübergreifend geteilter Container",
        "footer": "Mehrseitiger Fussbereich",
        "footerDescription": "Ein seitenübergreifend geteilter Container",
        "notAllowedUnlessTop": "Dieses Element ist nur im oberen Bereich der Seite erlaubt",
        "notAllowedUnlessBottom": "Dieses Element ist nur im unteren Bereich der Seite erlaubt",
        "notAllowedUnlessHeader": "Dieses Element ist nur im Kopfbereich der Seite erlaubt",
        "notAllowedUnlessFooter": "Dieses Element ist nur im Fussbereich der Seite erlaubt",
        "notAllowedInsideContainer": "Dieses Element ist nur außerhalb eines Containers erlaubt",
        "notAllowedInsideSameType": "Dieses Element ist nicht in einem Container der gleichen Art erlaubt",
        "ratingInput": "Bewertungseingabefeld",
        "ratingInputDescription": "Ein Bewertungs-Eingabeelement",
        "rating": "Bewertung",
        "ratingDescription": "Ein Bewertungs-Element",
        "invalidElementValue": "Ungültiger Elementwert: {value}",
        "notAllowedLocation": "Dieses Element ist an dieser Stelle nicht erlaubt",
        "menu": "Menü",
        "menuDescription": "Menü-Element",
        "simpleContainer": "Container",
        "simpleContainerDescription": "Ein Container für andere Elemente",
        "fileInput": "Dateieingabe",
        "fileInputDescription": "Ein Eingabefeld zum Hochladen von Dateien",
        "errorValueMissing": "Fehlende Eigenschaft \"Wert\"",
        "errorEmptyContainer": "Dieser Container ist leer",
        "errorParentWithDataSourceMissing": "Keine Datenquelle für das Element oder einen übergeordneten Container ausgewählt",
        "errorDataSourceMissing": "Keine Datenquelle ausgewählt",
        "errorSchemaPropertyMissing": "Keine Schema-Eigenschaft ausgewählt",
        "errorWorkflowActionInError": "Mindestens eine Aktion ist falsch konfiguriert",
        "errorCollectionFieldInError": "Mindestens ein Feld ist falsch konfiguriert",
        "errorNavigateToPageMissing": "Fehlende Eigenschaft \"Navigieren zu\"",
        "errorPageParameterInError": "Mindestens ein Seitenparameter ist falsch konfiguriert",
        "errorNavigationUrlMissing": "Fehlende Eigenschaft \"Navigations-URL\"",
        "errorImageFileMissing": "Fehlende Bild-Datei",
        "errorImageUrlMissing": "Fehlende Eigenschaft \"Bild-URL\"",
        "errorNoWorkflowAction": "Keine Workflow-Aktion konfiguriert",
        "errorOptionsMissing": "Keine Option konfiguriert",
        "errorIframeUrlMissing": "Fehlende Eigenschaft \"IFrame-URL\"",
        "errorIframeContentMissing": "Fehlender IFrame-Inhalt",
        "errorNoMenuItem": "Kein Menüpunkt konfiguriert",
        "errorMenuItemInError": "Mindestens ein Menü ist falsch konfiguriert",
        "errorSubMenuItemInError": "Mindestens ein Untermenü ist falsch konfiguriert"
    },
    "addElementButton": {
        "label": "Element"
    },
    "addElementModal": {
        "title": "Neues Element hinzufügen",
        "searchPlaceholder": "Elemente suchen",
        "elementInProgress": "Element wird hinzugefügt..."
    },
    "addElementCategory": {
        "suggestedElement": "Vorgeschlagene Elemente",
        "baseElement": "Grundelemente",
        "layoutElement": "Layout-Elemente",
        "formElement": "Formularelemente"
    },
    "elementMenu": {
        "drag": "Zum Neuanordnen ziehen",
        "moveUp": "Nach oben verschieben",
        "moveDown": "Nach unten verschieben",
        "moveLeft": "Nach links verschieben",
        "moveRight": "Nach rechts verschieben",
        "selectParent": "Übergeordnetes Element auswählen"
    },
    "duplicatePageJobType": {
        "name": "Seite duplizieren",
        "duplicating": "Duplizieren",
        "duplicatedTitle": "Seite dupliziert"
    },
    "pageSidePanelType": {
        "general": "Allgemein",
        "style": "Style",
        "visibility": "Sichtbarkeit",
        "events": "Ereignisse",
        "eventsTabDeactivatedNoEvents": "Dieses Element unterstützt keinerlei Ereignisse",
        "eventsTabInError": "Eine oder mehrere Aktionen sind falsch konfiguriert."
    },
    "emptySidePanelState": {
        "message": "Klicken Sie auf eines der Elemente, um weitere Details zu sehen"
    },
    "pagePreview": {
        "emptyMessage": "Anklicken, um ein Element zu erstellen",
        "fixedHeader": "FIXIERTER HEADER",
        "fixedFooter": "FIXIERTER FOOTER",
        "header": "KOPFBEREICH",
        "footer": "FUSSBEREICH"
    },
    "elementForms": {
        "textInputPlaceholder": "Text eingeben...",
        "urlInputPlaceholder": "URL eingeben...",
        "invalidFormula": "Die Formel ist ungültig"
    },
    "headingElement": {
        "missingValue": "Titel fehlt...",
        "emptyValue": "Leerer Titel..."
    },
    "headingElementForm": {
        "levelTitle": "Ebene",
        "textTitle": "Text",
        "textPlaceholder": "Text eingeben...",
        "headingName": "Überschrift {level} <h{level}>",
        "textError": "Der Wert ist ungültig."
    },
    "textElement": {
        "missingValue": "Fehlender Text...",
        "emptyValue": "Leerer Text..."
    },
    "textElementForm": {
        "textTitle": "Text",
        "textPlaceholder": "Text eingeben...",
        "textError": "Der Wert ist ungültig.",
        "textFormatTypeLabel": "Format",
        "textFormatTypePlain": "Klartext",
        "textFormatTypeMarkdown": "Markdown"
    },
    "orientations": {
        "label": "Ausrichtung",
        "horizontal": "Horizontal",
        "vertical": "Vertikal"
    },
    "menuElement": {
        "missingValue": "Fehlender Menüpunkt",
        "separator": "Trenner",
        "spacer": "Abstandshalter",
        "missingLinkValue": "Fehlender Link-Name...",
        "emptyLinkValue": "Leerer Link-Name...",
        "missingButtonValue": "Fehlender Button-Name...",
        "emptyButtonValue": "Leerer Button-Name..."
    },
    "menuElementForm": {
        "menuItemsLabel": "Menüpunkte",
        "addMenuItemLink": "Hinzufügen...",
        "alignment": "Ausrichtung",
        "menuItemDefaultName": "Seite",
        "menuItemLabelLabel": "Bezeichnung",
        "menuItemTypeLabel": "Typ",
        "menuItemTypeSeparator": "Trenner",
        "menuItemVariantLabel": "Variante",
        "menuItemVariantLink": "Verknüpfung",
        "menuItemVariantButton": "Button",
        "namePlaceholder": "Seite",
        "addSubLink": "Unterlink hinzufügen",
        "menuItemSubLinkDefaultName": "Unterlink",
        "menuItemAddLink": "Verknüpfung",
        "menuItemAddButton": "Button",
        "menuItemAddSeparator": "Trenner",
        "menuItemAddSpacer": "Abstandshalter",
        "eventDescription": "Um Aktionen für diesen Button zu konfigurieren, öffnen Sie die Registerkarte „Ereignisse“ dieses Elements.",
        "noMenuItemsMessage": "Klicken Sie auf 'Hinzufügen', um Ihren ersten Menüpunkt hinzuzufügen.",
        "variant": "Variante pro Gerätetyp",
        "expanded": "Ausgeklappt",
        "compact": "Kompakt",
        "previewCompactMenuLabel": "Vorschau des kompakten Menüs",
        "previewCompactMenuHelper": "Vorschau des kompakten Menüs ein-/ausblenden.",
        "openEditorCompactMenu": "Menü öffnen",
        "closeEditorCompactMenu": "Menü schließen"
    },
    "simpleContainerElementForm": {
        "noConfigurationOptions": "Das Container-Element verfügt über keine Konfigurationsoptionen."
    },
    "imageElement": {
        "missingValue": "Fehlender Alternativ-Text...",
        "emptyValue": "Leerer Alternativ-Text..."
    },
    "generalForm": {
        "labelTitle": "Bezeichnung",
        "labelPlaceholder": "Bezeichnung eingeben",
        "valueTitle": "Wert",
        "defaultValueTitle": "Standardwert",
        "defaultValuePlaceholder": "Standardwert eingeben",
        "valuePlaceholder": "Wert eingeben",
        "placeholderTitle": "Platzhalter",
        "placeholderPlaceholder": "Geben Sie einen Platzhalter ein",
        "requiredTitle": "Erforderlich",
        "validationTitle": "Überprüfung"
    },
    "inputTextElementForm": {
        "multilineTitle": "Mehrzeilig",
        "rowsTitle": "Zeilenanzahl",
        "rowsPlaceholder": "Geben Sie die Anzahl der Zeilen für diese Eingabe ein",
        "validationTypeAnyLabel": "Jeglich(e)",
        "validationTypeAnyDescription": "Erlaubt die Eingabe eines beliebigen Wertes.",
        "validationTypeIntegerLabel": "Zahl",
        "validationTypeIntegerDescription": "Erzwinge einen Zahlenwert in diesem Eingabefeld (akzeptiert Ganzzahlen und Dezimalzahlen).",
        "validationTypeEmailLabel": "E-Mailadresse",
        "validationTypeEmailDescription": "Erzwinge eine E-Mailadresse in diesem Eingabefeld.",
        "inputType": "Eingabetyp",
        "inputTypeTextLabel": "Text",
        "inputTypePasswordLabel": "Passwort",
        "passwordTypeWarning": "Passwörter sind sensible Daten. Bitte geben Sie acht, wie Sie Passwörter in Ihrer Anwendung behandeln und speichern."
    },
    "dateTimePickerElementForm": {
        "includeTime": "Zeit einbeziehen",
        "invalidDateError": "Ungültiges Datum. Bitte stellen Sie sicher, dass das eingegebene Datum dem angegebenen Format entspricht."
    },
    "imageElementForm": {
        "fileLabel": "Bild",
        "invalidUrlError": "URL ist ungültig",
        "altTextTitle": "Alternativer Text",
        "altTextDescription": "Wird von Screen-Readern verwendet und angezeigt, wenn das Bild nicht geladen werden kann",
        "fileSourceTypeUpload": "Hochladen",
        "fileSourceTypeURL": "URL",
        "urlWarning": "Hinweis: Bitte vergewissern Sie sich, dass Sie die Kontrolle über die eingegebene URL haben oder dieser vertrauen.",
        "uploadFileButton": "Datei hochladen"
    },
    "iframeElementForm": {
        "missingValue": "Fehlende IFrame-Quelle...",
        "emptyValue": "Leere IFrame-Quelle...",
        "sourceTypeLabel": "Quellen-Typ",
        "urlLabel": "URL",
        "urlPlaceholder": "Link zur externen Ressource, welche eingebettet werden soll",
        "urlHelp": "Hinweis: Bitte vergewissern Sie sich, dass Sie die Kontrolle über die eingegebene URL haben oder dieser vertrauen.",
        "allowSameOriginLabel": "Dem iFrame Zugriff auf die Daten seiner eigenen Website erlauben",
        "allowSameOriginHelp": "Aktivieren Sie dies nur für eine vertrauenswürdige externe URL. Es erlaubt dem iFrame, Cookies, Speicher und andere Same-Origin-Funktionen in Vorschauen und veröffentlichten Anwendungen zu verwenden.",
        "embedLabel": "Einbetten",
        "embedPlaceholder": "Reiner HTML-Inhalt, der eingebettet werden soll",
        "warningTitle": "Verwenden Sie nur vertrauenswürdige Inhalte",
        "warningMessage": "IFrame-Inhalte sind im Editor in einer Sandbox isoliert, wo eingebettetes HTML Skripte isoliert ausführen kann. In Vorschauen und veröffentlichten Anwendungen kann eingebettetes HTML ohne Einschränkungen ausgeführt werden, während externe URLs Skripte ausführen, Formulare absenden und Pop-ups öffnen können.",
        "heightLabel": "Höhe (px)",
        "heightPlaceholder": "Höhe in Pixeln"
    },
    "columnElementForm": {
        "columnAmountTitle": "Layout",
        "verticalAlignment": "Vertikale Ausrichtung",
        "columnAmountName": "keine Spalten | 1 Spalte | {columnAmount} Spalten",
        "columnGapTitle": "Abstand zwischen den Spalten",
        "columnGapPlaceholder": "Geben Sie den Abstand zwischen den Spalten ein...",
        "customLayout": "Benutzerdefiniert",
        "customWeightsTitle": "Benutzerdefinierte Spaltengewichte",
        "customWeightsHelper": "Verwenden Sie 0, wenn eine Spalte nur so breit wie ihr Inhalt sein soll. Die anderen Spalten teilen sich den verbleibenden Platz.",
        "errorCustomWeightsMinimum": "Spaltengewichte müssen 0 oder größer sein",
        "columnStackingTitle": "Spalten pro Gerätetyp stapeln",
        "columnStackingHorizontal": "Nebeneinander",
        "columnStackingStacked": "Gestapelt"
    },
    "domainSettings": {
        "titleOverview": "Domänen",
        "titleAddDomain": "Domäne hinzufügen",
        "addDomain": "Domäne hinzufügen",
        "noDomainMessage": "Sie haben noch keine Domäne mit dieser Anwendung verknüpft. Sie müssen eine Domäne hinzufügen, um Ihre Anwendung veröffentlichen zu können. Sie können verschiedene Versionen Ihrer Anwendung für jede hier aufgeführte Domäne veröffentlichen."
    },
    "userSourceSettings": {
        "titleAddUserSource": "Neue Benutzerquelle",
        "titleUpdateUserSource": "Benutzerquelle bearbeiten",
        "noUserSourceMessage": "Sie haben noch keine Benutzerquelle zu dieser Anwendung hinzugefügt. Sie müssen eine Benutzerquelle hinzufügen, wenn Sie möchten, dass die Benutzer Ihre Anwendung authentifizieren können.",
        "titleOverview": "Benutzerquellen",
        "addUserSource": "Benutzerquelle hinzufügen"
    },
    "themeSettings": {
        "titleOverview": "Theme"
    },
    "generalSettings": {
        "titleOverview": "Allgemein",
        "labelForm": "Favicon",
        "labelDescription": "Wählen Sie eine 128x128 Pixel große ICO-, PNG-, GIF- oder JPEG-Datei.",
        "labelButton": "Favicon hochladen",
        "cantUploadFaviconTitle": "Konnte die Favicon-Datei nicht hochladen",
        "cantUploadFaviconDescription": "Leider konnte kein Favicon-Bild hochgeladen werden. Bitte stellen Sie sicher, dass die Bilddatei eindeutig ist und in einem der unterstützten Bildformate vorliegt.",
        "cantUpdateApplicationTitle": "Konnte die Anwendung nicht aktualisieren",
        "cantUpdateApplicationDescription": "Entschuldigung, konnte die Anwendung nicht aktualisieren."
    },
    "dnsStatus": {
        "description": "Rufe die DNS-Einstellungen deiner Domäne auf und mache folgende Änderungen",
        "typeHeader": "Art",
        "hostHeader": "Host",
        "valueHeader": "Wert"
    },
    "domainForm": {
        "invalidDomain": "Der angegebene Name der Domäne ist ungültig",
        "notUniqueDomain": "Die angegebene Domäne wird bereits verwendet"
    },
    "customDomainForm": {
        "domainNameLabel": "Domänen-Name"
    },
    "subDomainForm": {
        "domainNameLabel": "Domänen-Name"
    },
    "subDomainDetails": {
        "text": "Die DNS-Einstellungen der Domäne sind bereits konfiguriert und überprüft worden. Es funktioniert, ohne dass zusätzliche Änderungen vorgenommen werden müssen."
    },
    "domainCard": {
        "refresh": "Einstellungen neu laden",
        "detailLabel": "Details anzeigen",
        "unpublishedDomainWarning": "Bitte veröffentlichen Sie die Anwendung, um sie auf dieser Domäne verfügbar zu machen."
    },
    "domainTypes": {
        "customName": "Benutzerdefinierte Domäne",
        "subDomainName": "Subdomain",
        "subDomain": "Subdomain von {domain}"
    },
    "linkElement": {
        "missingValue": "Fehlender Link-Text...",
        "emptyValue": "Leerer Link-Text..."
    },
    "linkNavigationSelection": {
        "navigateTo": "Navigieren zu",
        "navigateToCustom": "Benutzerdefinierte URL",
        "paramPlaceholder": "Geben Sie einen Wert ein...",
        "urlPlaceholder": "Geben Sie eine URL ein...",
        "url": "Ziel-URL",
        "paramsInErrorDescription": "Die gespeicherten Parameter stimmen nicht mit den Seitenparametern überein. Die Seite wurde wahrscheinlich gelöscht oder aktualisiert.",
        "paramsInErrorButton": "Parameter aktualisieren",
        "target": "Öffnen in...",
        "targetSelf": "Gleicher Tab",
        "targetNewTab": "Neuer Tab"
    },
    "linkElementForm": {
        "text": "Text",
        "textPlaceholder": "Text eingeben...",
        "variant": "Variante",
        "variantLink": "Verknüpfung",
        "variantButton": "Button",
        "buttonColor": "Buttonfarbe"
    },
    "widthSelector": {
        "width": "Breite",
        "widthAuto": "Auto",
        "widthFull": "Volle Breite"
    },
    "backgroundTypes": {
        "none": "Kein",
        "color": "Farbe"
    },
    "widthTypes": {
        "fullBleed": "Voller Beschnitt",
        "fullWidth": "Volle Breite",
        "normal": "Normal",
        "medium": "Mittel",
        "small": "Schmal"
    },
    "horizontalAlignmentSelector": {
        "alignmentLeft": "Links",
        "alignmentCenter": "Zentrieren",
        "alignmentRight": "Rechtsbündig"
    },
    "verticalAlignmentSelector": {
        "alignmentTop": "Oben",
        "alignmentCenter": "Mittig",
        "alignmentBottom": "Unten"
    },
    "pageSettingsTypes": {
        "pageName": "Seite"
    },
    "pageVisibilitySettingsTypes": {
        "pageName": "Sichtbarkeit",
        "logInPageWarningTitle": "Die Anmeldeseite ist nicht festgelegt",
        "logInPagewarningMessage": "Wenn ein anonymer Benutzer versucht, auf diese Seite zuzugreifen, wird er zu einer Anmeldeseite weitergeleitet. Bitte legen Sie die Anmeldeseite in den allgemeinen Einstellungen der Anwendung fest.",
        "logInPageInfoTitle": "Anonyme Benutzer werden weitergeleitet",
        "logInPageInfoMessage": "Anonyme Benutzer, die versuchen, auf diese Seite zuzugreifen, werden zur Seite {logInPageName} weitergeleitet."
    },
    "pageSettings": {
        "title": "Seite",
        "pageUpdatedTitle": "Geändert",
        "pageUpdatedDescription": "Die Seiteneinstellungen wurden geändert."
    },
    "pageVisibilitySettings": {
        "title": "Sichtbarkeit",
        "allVisitors": "Alle Besucher",
        "loggedInVisitors": "Eingeloggte Besucher",
        "description": "Wer darf diese Seite sehen"
    },
    "pageForm": {
        "defaultName": "Seite",
        "nameTitle": "Name",
        "nameSubtitle": "Eindeutiger Name der Seite",
        "namePlaceholder": "Geben Sie einen Namen ein...",
        "pathTitle": "Pfad",
        "addAnotherParameter": "Einen weiteren Abfrageparameter hinzufügen",
        "addParameter": "Einen Abfrageparameter hinzufügen",
        "queryParamsSubtitleTutorial": "Abfrageparameter können verwendet werden, um Daten abhängig von dem angegebenen Parameter dynamisch zu laden.",
        "pathSubtitle": "Ein Parameter kann über :parameter hinzugefügt werden",
        "pathPlaceholder": "Geben Sie einen Pfad ein...",
        "pathParamsTitle": "Pfad-Parameter",
        "queryParamsTitle": "Abfrageparameter",
        "pathParamsSubtitle": "Werden durch :parameter im Pfad definiert",
        "pathParamsSubtitleTutorial": "Pfad-Parameter können verwendet werden, um Daten dynamisch zu laden, abhängig von dem angegebenen Parameter. Fügen Sie :parameter zum Pfad hinzu, um einen hinzuzufügen."
    },
    "pathParamTypes": {
        "textName": "Text",
        "numericName": "Numerisch"
    },
    "queryParamTypes": {
        "textName": "Text",
        "numericName": "Numerisch"
    },
    "pageEditor": {
        "title": "Anwendungs-Builder",
        "pageNotFound": "Seite nicht gefunden"
    },
    "publicPage": {
        "siteNotFound": "Seite nicht gefunden",
        "pageNotFound": "Seite nicht gefunden",
        "loginToastTitle": "Authentifizierung erfolgreich",
        "loginToastMessage": "Sie wurden erfolgreich eingeloggt.",
        "authorizedToastTitle": "Authentifizierung erforderlich",
        "authorizedToastMessage": "Sie müssen angemeldet sein, um auf diese Seite zugreifen zu können. Bitte loggen Sie sich ein, um fortzufahren."
    },
    "integrationSettings": {
        "title": "Integrationen",
        "noIntegrationMessage": "Sie haben noch keine Integrationen erstellt. Diese können hinzugefügt werden, indem Sie eine Datenquelle, Aktion oder Benutzer-Authentifizierung hinzufügen.",
        "integrationMessage": "Sie können neue Integrationen erstellen, indem Sie eine Datenquelle, Aktion oder Benutzer-Authentifizierung hinzufügen."
    },
    "dataSourceForm": {
        "namePlaceholder": "Quellenname",
        "nameLabel": "Name",
        "actionLabel": "Aktion",
        "integrationLabel": "Integration",
        "servicePlaceholder": "Wählen Sie einen Dienst aus",
        "integrationPlaceholder": "Wählen Sie eine Integration aus",
        "searchActionPlaceholder": "Aktionen suchen",
        "noActionsFound": "Keine Aktionen gefunden",
        "errorUniqueName": "Der Name der Datenquelle muss eindeutig sein."
    },
    "dataSourceContext": {
        "addDataSource": "Neue Datenquelle hinzufügen",
        "noDataSourceTitle": "Sie haben noch keine Datenquellen hinzugefügt.",
        "noDataSourceMessage": "Datenquellen können verwendet werden, um Daten aus internen oder externen Quellen abzurufen und auf der Seite anzuzeigen.",
        "sharedDataSourceTitle": "Zwischen Seiten geteilt",
        "pageDataSourceTitle": "Für diese Seite",
        "sharedDataSourceDescription": "Ist auf jeder Seite verfügbar und wird einmalig beim ersten Laden der Seite abgerufen.",
        "pageDataSourceDescription": "Wird abgerufen, wenn der Benutzer auf diese Seite navigiert."
    },
    "dataSourceItem": {
        "notConfigured": "Nicht konfiguriert"
    },
    "dataSourceItemContext": {
        "shareBetweenPages": "Teilen zwischen Seiten",
        "unshareBetweenPages": "Freigabe auf anderen Seiten aufheben"
    },
    "dataSourceCreateEditModal": {
        "editTitle": "Datenquelle bearbeiten",
        "createTitle": "Datenquelle erstellen",
        "sharedWarning": "Diese Datenquelle wird gemeinsam genutzt, so dass sich Ihre Änderungen auf mehrere Seiten auswirken können."
    },
    "defaultStyleForm": {
        "boxTop": "Oben",
        "boxBottom": "Unten",
        "boxLeft": "Links",
        "boxRight": "Rechts",
        "backgroundLabel": "Hintergrund",
        "backgroundColor": "Hintergrundfarbe",
        "widthLabel": "Breite",
        "backgroundImage": "Bild",
        "backgroundImageMode": "Füllmodus",
        "cssClasses": "CSS-Klassen",
        "cssClassesHelp": "Geben Sie eine durch Leerzeichen getrennte Liste von Klassen für dieses Element ein, die im generierten HTML erscheinen.",
        "cssClassesPlaceholder": "CSS-Klassen eingeben..."
    },
    "styleBoxForm": {
        "borderColor": "Rahmenfarbe",
        "borderLabel": "Größe",
        "paddingLabel": "Innenabstand",
        "marginLabel": "Rand"
    },
    "radiusStyleForm": {
        "cornerRadiusLabel": "Eckradius",
        "backgroundRadiusLabel": "Hintergrund",
        "borderRadiusLabel": "Rahmen"
    },
    "themeConfigBlockType": {
        "color": "Farben",
        "page": "Seite",
        "typography": "Typografie",
        "button": "Button",
        "link": "Verknüpfung",
        "image": "Bild",
        "input": "Eingabefeld",
        "table": "Tabelle"
    },
    "colorThemeConfigBlock": {
        "transparent": "Transparent",
        "primaryColor": "Primär",
        "secondaryColor": "Sekundär",
        "borderColor": "Rahmen",
        "successColor": "Erfolgreich",
        "warningColor": "Warnung",
        "errorColor": "Fehler",
        "customColors": "Benutzerdefinierte Farben",
        "addCustomColor": "Benutzerdefinierte Farbe hinzufügen",
        "customColorPrefix": "Benutzerdefiniert"
    },
    "pageThemeConfigBlock": {
        "backgroundColor": "Hintergrundfarbe",
        "backgroundImage": "Hintergrundbild",
        "backgroundMode": "Hintergrundmodus"
    },
    "colorThemeConfigBlockType": {
        "transparent": "Transparent",
        "primary": "Primär",
        "secondary": "Sekundär",
        "border": "Rahmen",
        "success": "Erfolgreich",
        "warning": "Warnung",
        "error": "Fehler"
    },
    "typographyThemeConfigBlock": {
        "headingLabel": "Überschrift {i} (h{i})",
        "headingValue": "Überschrift <h{i}>",
        "color": "Farbe",
        "size": "Größe",
        "weight": "Gewicht",
        "textAlignment": "Ausrichtung",
        "bodyLabel": "Body",
        "decoration": "Textdekoration",
        "fontFamily": "Schriftart"
    },
    "fontWeightType": {
        "thin": "Dünn",
        "extraLight": "Extra-leicht",
        "light": "Leicht",
        "regular": "Regulär",
        "medium": "Mittel",
        "semiBold": "Semi-Bold",
        "bold": "Fett",
        "extraBold": "Extra-Bold",
        "black": "Black",
        "extraBlack": "Extra-Black"
    },
    "buttonThemeConfigBlock": {
        "backgroundColor": "Hintergrundfarbe",
        "button": "Button",
        "defaultState": "Standard-Zustand",
        "hoverState": "Hover-Zustand",
        "activeState": "Aktiver Zustand",
        "textAlignment": "Textausrichtung",
        "alignment": "Ausrichtung",
        "width": "Breite",
        "textColor": "Textfarbe",
        "borderColor": "Rahmenfarbe",
        "borderSize": "Rahmengröße",
        "borderRadius": "Rahmen-Radius",
        "padding": "Innenabstand",
        "fontFamily": "Schriftart",
        "size": "Schriftgröße",
        "weight": "Schriftgewicht"
    },
    "linkThemeConfigBlock": {
        "color": "Farbe",
        "link": "Link",
        "defaultState": "Standard-Zustand",
        "hoverState": "Hover-Zustand",
        "activeState": "Aktiver Zustand",
        "alignment": "Ausrichtung",
        "fontFamily": "Schriftart",
        "size": "Schriftgröße",
        "weight": "Schriftgewicht",
        "decoration": "Textdekoration"
    },
    "inputThemeConfigBlock": {
        "label": "Beschriftung",
        "input": "Eingabe",
        "backgroundColor": "Hintergrundfarbe",
        "textColor": "Textfarbe",
        "borderColor": "Rahmenfarbe",
        "borderSize": "Rahmengröße",
        "borderRadius": "Rahmen-Radius",
        "padding": "Innenabstand",
        "fontFamily": "Schriftart",
        "size": "Schriftgröße",
        "weight": "Schriftgewicht"
    },
    "imageThemeConfigBlock": {
        "alignment": "Ausrichtung",
        "maxWidthLabel": "Maximale Breite",
        "maxHeightLabel": "Maximale Höhe",
        "maxHeightPlaceholder": "Geben Sie die maximale Höhe ein",
        "maxWidthPlaceholder": "Geben Sie die maximale Breite ein",
        "imageConstraintsLabel": "Beschränkungen",
        "imageConstraintFullWidth": "Auf maximale Breite ausweiten",
        "imageConstraintCover": "Cover",
        "imageConstraintCoverDisabled": "Nicht verfügbar bei leerer maximaler Höhe.",
        "imageConstraintContain": "Contain",
        "imageConstraintContainDisabled": "Nicht verfügbar mit maximaler Höhe.",
        "imageBorderRadiusLabel": "Randradius",
        "imageBorderRadiusPlaceholder": "Geben Sie den Bildrand-Radius ein."
    },
    "tableThemeConfigBlock": {
        "borderColor": "Rahmenfarbe",
        "backgroundAlternateColor": "Gerade Zeilenfarbe",
        "backgroundColor": "Hintergrundfarbe",
        "textColor": "Textfarbe",
        "borderSize": "Rahmengröße",
        "borderRadius": "Rahmen-Radius",
        "padding": "Innenabstand",
        "fontFamily": "Schriftart",
        "size": "Größe",
        "fontSize": "Schriftgröße",
        "fontWeight": "Schriftgewicht",
        "table": "Tabelle",
        "header": "Kopfbereich",
        "alignment": "Ausrichtung",
        "cells": "Zellen",
        "separators": "Trennelemente",
        "verticalSeparatorColor": "Vertikale Farbe",
        "verticalSeparatorSize": "Vertikale Größe",
        "horizontalSeparatorColor": "Horizontale Farbe",
        "horizontalSeparatorSize": "Horizontale Größe"
    },
    "buttonElementForm": {
        "valueLabel": "Button-Text",
        "valuePlaceholder": "Text eingeben..."
    },
    "buttonElement": {
        "missingValue": "Fehlender Button-Text...",
        "emptyValue": "Leerer Button-Text..."
    },
    "eventTypes": {
        "clickLabel": "Bei Klick",
        "submitLabel": "Beim Absenden",
        "afterLoginLabel": "Nach dem Login"
    },
    "getExpressionComponent": {
        "errorTooltip": "Ungültige Referenz"
    },
    "getFormulaComponent": {
        "errorTooltip": "Ungültiger Bezug"
    },
    "fontSidePanelForm": {
        "label": "Schriftfarbe"
    },
    "choiceElementForm": {
        "multiple": "Mehrere Werte zulassen",
        "display": "Anzeige",
        "dropdown": "Drop-Down",
        "checkbox": "Kontrollfeld",
        "radio": "Option"
    },
    "dropdown": {
        "empty": "Keine Optionen verfügbar"
    },
    "tableElementForm": {
        "dataSource": "Datenquelle",
        "fields": "Felder",
        "fieldValueLabel": "Wert",
        "addField": "Feld hinzufügen",
        "fieldValuePlaceholder": "Wert eingeben...",
        "itemsPerPage": "Elemente pro Seite",
        "fieldDefaultName": "Spalte",
        "name": "Name",
        "noName": "Kein Name",
        "fieldType": "Typ",
        "itemsPerPagePlaceholder": "Wert eingeben...",
        "selectSourceFirst": "Wählen Sie eine Datenquelle und/oder Eigenschaft, um mit der Konfiguration Ihrer Felder zu beginnen.",
        "buttonColor": "Buttonfarbe",
        "refreshFieldsFromDataSource": "Felder aus der Datenquelle aktualisieren",
        "buttonLoadMoreLabel": "Mehr anzeigen-Beschriftung",
        "propertySelectorMissingArrays": "Keine Felder mit mehreren Werten gefunden, die als Zeilen verwendet werden können."
    },
    "tableElement": {
        "showMore": "Mehr anzeigen"
    },
    "abTable": {
        "loading": "Wird geladen...",
        "empty": "Es wurden keine Elemente gefunden."
    },
    "repeatElement": {
        "empty": "Es wurden keine Elemente gefunden.",
        "showMore": "Mehr anzeigen",
        "missingDataSourceTooltip": "Wählen Sie eine Datenquelle, um mit dem Hinzufügen von Elementen zu beginnen.",
        "missingSchemaPropertyTooltip": "Wählen Sie eine Eigenschaft, um mit dem Hinzufügen von Elementen zu beginnen.",
        "emptyState": "Keine Einträge gefunden."
    },
    "collectionElementForm": {
        "noDataSourceMessage": "Wählen Sie eine Datenquelle mit mehreren Zeilen, um alle Ergebnisse aufzulisten, oder eine einzeilige Datenquelle, um eine Eigenschaft innerhalb dieser Zeile auszuwählen.",
        "noSchemaPropertyMessage": "Wählen Sie eine Eigenschaft in der Datenquelle, die Sie als Listendaten für Ihr Element verwenden möchten.",
        "propertyOptionLabel": "Benutzeraktionen"
    },
    "propertyOptionForm": {
        "fieldHeading": "Feld",
        "filterHeading": "Filter",
        "sortHeading": "Sortierung",
        "searchHeading": "Suche",
        "optionUnavailable": "Nicht verfügbar",
        "noPropertiesAvailable": "Keine Felder verfügbar.",
        "formDescription": "Wählen Sie aus, welche Eigenschaften innerhalb der Datenquelle dieses Elements von Seitenbesuchern gefiltert, sortiert und durchsucht werden können."
    },
    "repeatElementForm": {
        "dataSource": "Datenquelle",
        "itemsPerPage": "Elemente pro Seite",
        "itemsPerPagePlaceholder": "Wert eingeben...",
        "itemsPerRowLabel": "Elemente pro Zeile",
        "itemsPerRowDescription": "Anzahl der Spalten pro Zeile und Gerätetyp.",
        "buttonLoadMoreLabel": "Mehr anzeigen-Beschriftung",
        "toggleEditorRepetitionsLabel": "Wiederholungen vorübergehend deaktivieren",
        "propertySelectorMissingArrays": "Keine Felder mit mehreren Werten gefunden, mit denen wiederholt werden kann.",
        "gapLabel": "Abstand zwischen Wiederholungen",
        "gapVerticalLabel": "Vertikal",
        "gapHorizontalLabel": "Horizontal"
    },
    "recordSelectorElement": {
        "emptyAdhocState": "Keine Datensätze gefunden, die '{query}' entsprechen.",
        "emptyState": "Keine Einträge gefunden."
    },
    "recordSelectorElementForm": {
        "selectRecordsFrom": "Datensätze auswählen aus",
        "noDataSourceMessage": "Wählen Sie eine Datenquelle mit mehreren Zeilen, um alle Ergebnisse aufzulisten.",
        "optionNameSuffix": "Suffix für Optionsnamen",
        "optionNameSuffixPlaceholder": "Geben Sie ein Suffix ein...",
        "optionNameSuffixHelper": "Dieses Suffix wird beim Öffnen des Dropdowns an jeden Optionsnamen angehängt und hilft dabei, sie zu unterscheiden.",
        "itemsPerPage": "Elemente pro Seite",
        "itemsPerPagePlaceholder": "Wert eingeben...",
        "multipleLabel": "Mehrere Werte zulassen",
        "record": "Datensatz {id}"
    },
    "currentRecordDataProviderType": {
        "index": "Index",
        "firstPartName": "Datenquelle: {name}",
        "schemaProperty": "{prefixName}: {schemaProperty}"
    },
    "workflowActionTypes": {
        "notificationLabel": "Benachrichtigung anzeigen",
        "notificationDescription": "Dem Benutzer eine Benachrichtigung anzeigen.",
        "openPageLabel": "Seite öffnen",
        "openPageDescription": "Den Benutzer zu einer anderen Seite oder URL navigieren.",
        "logoutLabel": "Abmelden",
        "logoutDescription": "Den aktuellen Benutzer abmelden.",
        "refreshDataSourceLabel": "Datenquelle aktualisieren",
        "refreshDataSourceDescription": "Eine Datenquelle neu laden und die Elemente aktualisieren, die sie verwenden.",
        "httpRequest": "HTTP-Anfrage senden",
        "errorNavigateToPageMissing": "Fehlende Eigenschaft \"Navigieren zu\"",
        "errorPageParameterInError": "Mindestens ein Seitenparameter ist falsch konfiguriert",
        "errorNavigationUrlMissing": "Fehlende Eigenschaft \"Navigations-URL\"",
        "errorDataSourceMissing": "Keine Datenquelle ausgewählt"
    },
    "notificationWorkflowActionForm": {
        "titleLabel": "Titel",
        "titlePlaceholder": "Text eingeben...",
        "descriptionLabel": "Beschreibung",
        "descriptionPlaceholder": "Text eingeben..."
    },
    "event": {
        "addAction": "Aktion hinzufügen",
        "searchActions": "Aktionen suchen",
        "noActionsFound": "Keine Aktionen gefunden"
    },
    "collectionFieldType": {
        "boolean": "Boolesch",
        "button": "Button",
        "text": "Text",
        "link": "Verknüpfung",
        "tags": "Tags",
        "image": "Bild",
        "rating": "Bewertung",
        "errorValueMissing": "Fehlende Eigenschaft \"Wert\""
    },
    "textFieldForm": {
        "fieldValueLabel": "Wert",
        "fieldValuePlaceholder": "Wert eingeben..."
    },
    "linkFieldForm": {
        "fieldValueLabel": "URL",
        "fieldValuePlaceholder": "Wert eingeben...",
        "fieldLinkNameLabel": "Verknüpfungstext",
        "fieldLinkNamePlaceholder": "Wert eingeben...",
        "buttonColor": "Buttonfarbe"
    },
    "tagsFieldForm": {
        "fieldValuesLabel": "Werte",
        "fieldValuesPlaceholder": "Werte eingeben...",
        "fieldColorsLabel": "Farben",
        "fieldColorsPlaceholder": "Farben eingeben..."
    },
    "linkField": {
        "details": "Details"
    },
    "imageFieldForm": {
        "fieldSrcLabel": "Bildquelle",
        "fieldSrcPlaceholder": "Wert eingeben",
        "fieldAltLabel": "Alternativer Text",
        "fieldAltPlaceholder": "Wert eingeben...",
        "fieldAltHelp": "Wird von Screen-Readern verwendet und angezeigt, wenn das Bild nicht geladen werden kann"
    },
    "createUserSourceForm": {
        "userSourceType": "Typ",
        "userSourceIntegration": "Integration",
        "userSourceName": "Name"
    },
    "updateUserSourceForm": {
        "nameFieldLabel": "Name",
        "nameFieldPlaceholder": "Einen Namen eingeben...",
        "authTitle": "Authentifizierung",
        "integrationFieldLabel": "Integration",
        "addProvider": "Anbieter hinzufügen"
    },
    "builderLoginPageForm": {
        "pageDropdownLabel": "Anmeldeseite",
        "pageDropdownPlaceholder": "Wählen Sie eine Seite aus",
        "pageDropdownDescription": "Wählen Sie die Anmeldeseite aus, zu der nicht angemeldete Benutzer weitergeleitet werden sollen, wenn sie versuchen, auf eine geschützte Seite zuzugreifen."
    },
    "formContainerElement": {
        "submitDeactivatedText": "Füllen Sie alle erforderlichen Felder aus, um das Formular abzusenden",
        "defaultSubmitButtonLabel": "Absenden"
    },
    "formContainerElementForm": {
        "submitButtonLabel": "Absenden-Button",
        "submitButtonPlaceholder": "Wert eingeben...",
        "buttonColor": "Buttonfarbe",
        "resetToInitialValuesTitle": "Nach der Übermittlung auf Standardwerte zurücksetzen",
        "resetToInitialValuesDescription": "Wenn diese Option aktiviert ist, werden die Standardwerte des Formulars verwendet, um das Formular nach erfolgreicher Übermittlung zurückzusetzen. Falls der Haken nicht gesetzt ist, bleiben die Werte des Benutzers erhalten."
    },
    "choiceOptionSelector": {
        "label": "Optionen",
        "value": "Optionswerte",
        "valuePlaceholder": "Wert eingeben",
        "name": "Optionsnamen",
        "namePlaceholder": "Name eingeben",
        "addOption": "Option hinzufügen",
        "addOptionDescription": "Klicken Sie auf 'Option hinzufügen', um Ihrem Dropdown Optionen hinzuzufügen",
        "optionType": "Optionstyp",
        "manual": "Manuell",
        "dataSource": "Datenquelle",
        "expressions": "Ausdrücke",
        "formulas": "Formeln"
    },
    "fieldMappingContext": {
        "enableField": "Feld aktivieren",
        "disableField": "Feld deaktivieren"
    },
    "checkboxElementForm": {
        "labelTitle": "Optionsname",
        "valueTitle": "Standardwert",
        "requiredTitle": "Erforderlich"
    },
    "choiceElement": {
        "addOptions": "Fügen Sie Optionen hinzu, um dieses Element zu verwenden..."
    },
    "userSourceUsersContext": {
        "searchPlaceholder": "Benutzer suchen",
        "anonymous": "Anonym",
        "unnamed": "Unbenannt",
        "noEmail": "Keine E-Mailadresse"
    },
    "userSelector": {
        "viewAs": "Anzeigen als: {user}",
        "anonymous": "Anonym",
        "member": "{prefix} Mitglied"
    },
    "visibilityForm": {
        "allVisitors": "Alle Besucher",
        "loggedInVisitors": "Eingeloggte Besucher",
        "notLoggedInVisitors": "Ausgeloggte Besucher",
        "warningTitle": "Dies ist eine Sicherheitsfunktion",
        "warningMessage": "Sehen Sie die {link}, um mehr über den Schutz der Daten zu erfahren.",
        "documentationLink": "Dokumentation",
        "excludedRolesLabel": "alle Rollen außer",
        "switchAllowLabel": "Erlauben",
        "switchDisallowLabel": "Verbieten",
        "rolesSelectAll": "Alle auswählen",
        "rolesDeselectAll": "Alle abwählen",
        "rolesSelectHint": "Wählen Sie eine oder mehrere Rollen aus",
        "roleTypesHint": "Wählen Sie einen Rollentyp aus",
        "roleTypeAllowAllRoles": "Alle Rollen",
        "roleTypeAllowAllRolesExcept": "Rollen verbieten...",
        "roleTypeDisallowAllRolesExcept": "Rollen erlauben...",
        "rolesAllMembersOf": "Alle Mitglieder von {name}",
        "noRole": "Keine Rolle",
        "errorFetchingRolesTitle": "Konnte Benutzerrollen nicht abrufen",
        "errorFetchingRolesMessage": "Beim Abrufen der Benutzerrollen ist ein Fehler aufgetreten.",
        "visibilityCondition": "Sichtbarkeitsbedingung",
        "visibilityConditionHelper": "Wenn das Ergebnis dieser Formel wahr ist und die obige Besucherauswahl wahr ist, wird das Element sichtbar sein. Diese Bedingung wirkt sich nur auf die Sichtbarkeit des Elements aus. Um Daten stattdessen aus der Server-Antwort auszuschließen, verwenden Sie die obige Filteroption für Benutzerrollen.",
        "visibilityConditionPlaceholder": "Bedingung..."
    },
    "userDataProviderType": {
        "isAuthenticated": "Ist authentifiziert",
        "id": "ID",
        "email": "E-Mailadresse",
        "username": "Benutzername",
        "role": "Rolle"
    },
    "buttonField": {
        "noLabel": "Unbenannt..."
    },
    "buttonFieldForm": {
        "infoMessage": "Um Aktionen für diese Schaltfläche zu konfigurieren, öffnen Sie die Registerkarte „Ereignisse“ des aktuellen Elements.",
        "labelPlaceholder": "Geben Sie eine Bezeichnung ein..."
    },
    "resetButton": {
        "reset": "Auf Standard-Theme-Wert zurücksetzen"
    },
    "backgroundModes": {
        "fill": "Füllen",
        "tile": "Kachel",
        "fit": "Anpassen"
    },
    "customStyle": {
        "backToElement": "Zurück zur Elementkonfiguration",
        "configureThemeOverrides": "Theme-Überschreibungen für dieses Element konfigurieren"
    },
    "serviceSchemaPropertySelector": {
        "label": "Eigenschaft",
        "noProperties": "Keine Eigenschaften verfügbar"
    },
    "userSourceDropdown": {
        "label": "Benutzerquelle",
        "addUserSource": "Neue Benutzerquelle hinzufügen",
        "noUserSources": "Keine Benutzerquellen verfügbar"
    },
    "dataSourceDropdown": {
        "label": "Datenquelle",
        "noDataSources": "Keine Datenquellen verfügbar",
        "noSharedDataSources": "Keine geteilten Datenquellen verfügbar",
        "shared": "geteilt",
        "pageOnly": "diese Seite",
        "addNew": "Neue Datenquelle hinzufügen"
    },
    "multiPageContainerElementForm": {
        "pagePosition": "Position",
        "behaviour": "Verhalten",
        "display": "Anzeige",
        "selectAll": "Alle auswählen",
        "deselectAll": "Alle abwählen"
    },
    "pageShareType": {
        "all": "Auf allen Seiten",
        "only": "Nur auf ausgewählten Seiten",
        "except": "Ausgewählte Seiten ausschließen"
    },
    "authProviderWithModal": {
        "authProviderInError": "Bitte bearbeiten Sie diesen Anbieter, um den Fehler zu beheben.",
        "title": "Anbieter bearbeiten: {name}"
    },
    "textDecorationSelector": {
        "underline": "Unterstrichen",
        "stroke": "Durchgestrichen",
        "italic": "Kursiv",
        "uppercase": "Großbuchstaben"
    },
    "ratingFieldForm": {
        "maxValue": "Maximaler Wert",
        "color": "Farbe",
        "style": "Stil",
        "star": "Stern",
        "heart": "Herz",
        "thumbsUp": "Daumen hoch",
        "flag": "Flagge",
        "value": "Wert"
    },
    "ratingElementForm": {
        "maxValue": "Maximum",
        "color": "Farbe",
        "ratingStyle": "Stil",
        "star": "Stern",
        "heart": "Herz",
        "smile": "Smiley",
        "thumbsUp": "Daumen hoch",
        "flag": "Flagge"
    },
    "automationSettingsModal": {
        "title": "Workflow"
    },
    "abFileInput": {
        "delete": "Löschen"
    },
    "elementsGuidedTourStep": {
        "title": "Fügen Sie Elemente zu Ihrer Seite hinzu",
        "content": "Jede Anwendung benötigt Komponenten! Fügen Sie Elemente wie Tabellen, Formulare, Buttons und mehr hinzu, um Ihre Anwendung zum Leben zu erwecken."
    },
    "dataGuidedTourStep": {
        "title": "Verbinden Sie Ihre Daten",
        "content": "Verknüpfen Sie hier Ihre Baserow-Tabellen, um Ihre Daten dynamisch in verschiedenen Elementen anzuzeigen, zu filtern und zu aktualisieren."
    },
    "previewGuidedTourStep": {
        "title": "Ihr Steuerungszentrum",
        "content": "Hier konfigurieren Sie die Seiten Ihrer Anwendung. Fügen Sie Elemente hinzu, sehen Sie sich das Ergebnis in der Vorschau an und strukturieren Sie Ihre Anwendung genau so, wie Sie es möchten."
    },
    "devicesGuidedTourStep": {
        "title": "Vorschau auf verschiedenen Geräten",
        "content": "Wechseln Sie zwischen Desktop-, Tablet- und Mobil-Vorschauen, um zu sehen, wie Ihre Anwendung auf verschiedenen Bildschirmgrößen aussieht. Stellen Sie sicher, dass Ihr Design auf allen Geräten perfekt funktioniert!"
    },
    "sidePanelGuidedTourStep": {
        "title": "Seitenpanel: Elemente anpassen",
        "content": "**Allgemein-Tab** – Konfigurieren Sie das ausgewählte Element.\n\n**Style-Tab** – Passen Sie Innenabstand, Außenabstand, Rahmen und mehr an.\n\n**Sichtbarkeit-Tab** – Steuern Sie, wer dieses Element sehen kann: eingeloggte Benutzer, ausgeloggte Benutzer oder bestimmte Rollen.\n\n**Ereignisse-Tab** – Wenn das Element Aktionen unterstützt, konfigurieren Sie diese hier für dynamische Interaktivität."
    },
    "previewPublishGuidedTourStep": {
        "title": "Vorschau & Veröffentlichung Ihrer Anwendung",
        "content": "Klicken Sie auf **Vorschau**, um Ihre Anwendung privat zu testen. Wenn Sie bereit sind, klicken Sie auf **Veröffentlichen**, um sie über eine Domäne mit der Öffentlichkeit zu teilen."
    },
    "pageElementBehaviour": {
        "normal": "Normal",
        "fixed": "Fixiert"
    },
    "workflowAction": {
        "sampleDataModalTitle": "Payload für {actionLabel}",
        "sampleDataModalSubTitle": "JSON-Payload",
        "testActionDescription": "Führen Sie diese Aktion in der Vorschau aus, um ihre Ausgabe zu erfassen und für nachfolgende Aktionen verfügbar zu machen."
    }
}
